import IssuerListContainer from '../helpers/IssuerListContainer';

class OnlineBankingFI extends IssuerListContainer {
    public static readonly type = 'ebanking_FI';
}

export default OnlineBankingFI;
